


















import Vue from 'vue';
export default Vue.extend({
  name: 'DialogBase',
  props: {
    title: String,
    buttonColor: String,
  },
});
